import apiClient from "./client";

export const supportApi = {
  getClientTickets: async () => {
    const response = await apiClient.get("/support/tickets");
    return response.data;
  },

  createClientTicket: async (ticket) => {
    const response = await apiClient.post("/support/tickets", ticket);
    return response.data;
  },

  getClientTicket: async (ticketId) => {
    const response = await apiClient.get(`/support/tickets/${ticketId}`);
    return response.data;
  },

  sendClientMessage: async (ticketId, message) => {
    const response = await apiClient.post(
      `/support/tickets/${ticketId}/messages`,
      { message },
    );
    return response.data;
  },

  createPublicTicket: async (ticket) => {
    const response = await apiClient.post("/support/public/tickets", ticket);
    return response.data;
  },

  getPublicTicket: async (ticketId, accessToken) => {
    const response = await apiClient.get(`/support/public/tickets/${ticketId}`, {
      headers: { "X-Ticket-Access-Token": accessToken },
    });
    return response.data;
  },

  sendPublicMessage: async (ticketId, accessToken, message) => {
    const response = await apiClient.post(
      `/support/public/tickets/${ticketId}/messages`,
      { message },
      { headers: { "X-Ticket-Access-Token": accessToken } },
    );
    return response.data;
  },

  getAdminTickets: async () => {
    const response = await apiClient.get("/support/admin/tickets");
    return response.data;
  },

  getAdminTicket: async (ticketId) => {
    const response = await apiClient.get(`/support/admin/tickets/${ticketId}`);
    return response.data;
  },

  sendAdminMessage: async (ticketId, message) => {
    const response = await apiClient.post(
      `/support/admin/tickets/${ticketId}/messages`,
      { message },
    );
    return response.data;
  },

  updateAdminTicketStatus: async (ticketId, status) => {
    const response = await apiClient.patch(
      `/support/admin/tickets/${ticketId}/status`,
      { status },
    );
    return response.data;
  },

  deleteAdminTicket: async (ticketId) => {
    const response = await apiClient.delete(`/support/admin/tickets/${ticketId}`);
    return response.data;
  },

  deleteAdminTickets: async (ticketIds) => {
    const response = await apiClient.delete("/support/admin/tickets", {
      data: { ticketIds },
    });
    return response.data;
  },

  archiveAdminTickets: async (ticketIds) => {
    const response = await apiClient.post("/support/admin/archive", {
      ticketIds,
    });
    return response.data;
  },

  getAdminArchives: async (filters = {}) => {
    const response = await apiClient.get("/support/admin/archive", {
      params: filters,
    });
    return response.data;
  },

  getAdminArchive: async (archiveId) => {
    const response = await apiClient.get(
      `/support/admin/archive/${archiveId}`,
    );
    return response.data;
  },

  deleteAdminArchives: async (archiveIds) => {
    const response = await apiClient.delete("/support/admin/archive", {
      data: { archiveIds },
    });
    return response.data;
  },

  exportAdminConversations: async ({ ticketIds, archiveIds, password }) => {
    const response = await apiClient.post(
      "/support/admin/export",
      { ticketIds, archiveIds, password },
      { responseType: "blob" },
    );
    return response.data;
  },

  getGuestRetentionPolicy: async () => {
    const response = await apiClient.get("/support/admin/guest-retention");
    return response.data;
  },

  updateGuestRetentionPolicy: async (policy) => {
    const response = await apiClient.put(
      "/support/admin/guest-retention",
      policy,
    );
    return response.data;
  },
};